import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as LinkTo } from "react-router";
import RefreshButton from "../../../../../common/components/refresh_button";
import { TabCadastroContent } from "./components/tab_cadastro_content";
import { useQualidadeCadastroAcoesPreventivasViewModel } from "../../viewModels/qualidade_cadastro_acoes_preventivas_view_model";
import BottomBar from "../../../../../common/components/bottom_bar";
import { BackButton } from "../../../../../common/components/back_button";
import { isValidId } from "../../../../../common/utils/utils";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";

export const CadastroAcoesPreventivas = () => {
  const viewModel = useQualidadeCadastroAcoesPreventivasViewModel();
  const numeroValue = viewModel.hookForm.watch("Numero");
  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          leftSlot={
            <div className="flex flex-row items-center gap-6 bg-white px-5 py-2 rounded-lg border border-gray-200 shadow-sm ml-6 h-[50px]">
              <div className="flex flex-row items-center gap-3">
                <span className="text-sm text-gray-500 uppercase font-bold tracking-wider">
                  Status:
                </span>
                <div className="flex items-center">
                  <FormRadioGroupInput
                    name="AcaoAberta"
                    boldOptionsLabel={true}
                    options={[
                      { id: 0, label: "Fechado" },
                      { id: 1, label: "Aberto" },
                    ]}
                    reactHookForm={viewModel.hookForm}
                  />
                </div>
              </div>

              <div className="w-px h-8 bg-gray-200"></div>

              <div className="flex flex-col justify-center">
                <span className="text-[10px] text-gray-500 uppercase font-bold tracking-wider">
                  Número
                </span>
                <span className="text-sm font-bold text-emerald-600 mt-0.5">
                  {numeroValue || "-"}
                </span>
              </div>
            </div>
          }
          rightSlot={
            <div className="mr-6">
              <BackButton
                onClick={() =>
                  viewModel.handleVoltarcoesPreventivas("Preventivas")
                }
              />
            </div>
          }
        />
      </PageTopBar>
      <form className="pb-8" onSubmit={viewModel.handleSubmit}>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Qualidade
            </Link>
            <Link underline="hover" color="inherit">
              <LinkTo to="/AcoesPreventivas_lista">Ações de Melhorias</LinkTo>
            </Link>
            <Typography className="text-primary-green">
              Cadastro de Ações de Melhorias
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">
                Cadastro de Ações de Melhorias
              </h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>

          <TabCadastroContent
            hookForm={viewModel.hookForm}
            loading={false}
            centroCustoLista={viewModel.filters.centroDeCustoLista ?? []}
            handleArquivoDeleteOpenState={viewModel.handleFileChange}
            handleDownload={viewModel.handleDownloadFile}
            selectedAcoesPrevintivas={viewModel.selectecoesPreventiva}
            saving={viewModel.saving}
            IdAcaoQualidade={viewModel.idAcaoQualidade}
            hookFormPrev={viewModel.hookFormPrev}
            onSubmitPrev={viewModel.handleAcaoPrevSubmit}
            handleDeleteConfirmaPrev={viewModel.handleDeleteConfirmaPrev}
            handleRowsPerTablePrevChange={
              viewModel.handleRowsPerTablePrevChange
            }
            handleTablePrevChange={viewModel.handleTablePrevChange}
            loadingPrev={viewModel.loadingPrev}
            qualidadeAcaoPrevCorretivaLista={viewModel.acaoPrevCorretivaLista}
            paginationPrev={viewModel.paginationPrev}
            onOpenChangeHistory={(id, tabelaTipo) =>
              viewModel.handleOpenChangeHistory(id, tabelaTipo)
            }
          />
        </div>
        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {isValidId(viewModel.idAcaoQualidade) && (
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory(null, null)}
                >
                  <span className="text-xs">Historico de alterações</span>
                </PrimaryButton>
              )}
            </div>
            <div className="flex flex-row gap-4 ml-auto">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={() =>
                    viewModel.handleVoltarcoesPreventivas("Preventivas")
                  }
                >
                  {viewModel.idAcaoQualidade ? <>Fechar</> : <>Cancelar</>}
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving ? (
                  <PrimaryButton>Salvando...</PrimaryButton>
                ) : (
                  <PrimaryButton
                    type="submit"
                    onClick={viewModel.handleSubmit}
                    startIcon={
                      <DynamicIcon
                        nameIcon="CheckRounded"
                        size={25}
                        className="text-white"
                      />
                    }
                  >
                    Salvar
                  </PrimaryButton>
                )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>
      <ChangeHistoryModal changeHistoryHandler={viewModel.changeHistory} />
    </>
  );
};
